<template>
  <div class="earnings">
    <div class="earnings-headline">
      <!--第二模块  列表搜索-->
      <div class="headline-third">
        <div class="headline-third-top">
          <div class="headline-third0">
            <div class="headline-third0-title">用户ID</div>
            <el-input
              v-model="userId"
              placeholder="请输入用户ID"
              clearable
            ></el-input>
          </div>
          <div class="headline-third0">
            <div class="headline-third0-title">用户手机号</div>
            <el-input
              v-model="userPhone"
              placeholder="请输入手机号"
              clearable
            ></el-input>
          </div>
          <div class="headline-third0" style="margin-right: 28px">
            <div class="headline-third0-title">订单号</div>
            <el-input
              v-model="userOrder"
              placeholder="请输入订单号"
              clearable
            ></el-input>
          </div>
          <div class="headline-third1">
            <div class="headline-third1-title">用户付款时间</div>
            <el-date-picker
              v-model="receiptValue"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="headline-third-bottom">
          <div class="headline-third1-bottom" @click="submitBtn">查询</div>
        </div>
      </div>

      <!--第三模块  列表表格-->
      <div class="headline-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{
            'text-align': 'center',
            background: '#FAFAFA ',
          }"
        >
          <el-table-column prop="pay_userId" label="用户id" align="center">
          </el-table-column>
          <el-table-column prop="pay_phone" label="用户手机号" align="center">
          </el-table-column>
          <el-table-column prop="ordernumGood" label="用户订单号" align="center">
          </el-table-column>
          <el-table-column prop="payTime" label="用户付款时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.payTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="收益面值" align="center">
            <template slot-scope="scope"> ￥{{ scope.row.price }} </template>
          </el-table-column>
          <el-table-column label="收益状态" align="center">
            <template slot-scope="scope">
              <div
                class="earningStatusColor"
                :style="{
                  color: scope.row.status == 'ENTER' ? '#f9b63c' : '#666666',
                }"
              >
                {{
                  scope.row.status == 'ENTER'
                    ? '已入账'
                    : scope.row.status == 'WAIT'
                    ? '待入账'
                    : scope.row.status == 'PAST'
                    ? '已过期'
                    : ''
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--第四模块  分页模块-->
      <div class="headline-paging" v-if="totalNum > 10">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="10"
          layout="prev, pager, next, sizes, jumper"
          :total="totalNum"
          :pager-count="11"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getBalance, postBalance } from '../../api/partenr'

import { formatDate } from '../../utils/date'
import Bus from '../../utils/bus'
export default {
  filters: {
    formatDate(time) {
      time = time * 1000 //注意：time应为格式为13位unix时间戳，如果是10位的unix时间戳，需要乘以1000
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
  },
  data() {
    return {
      // 列表条数
      limit: 10,
      // 列表页码
      page: 1,
      // 确认收货时间输入框
      receiptValue: [],
      // 时间区间
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      // 搜索弹出框
      dialogVisible: false,
      // 收益明细列表对象
      eamingObj: {},
      // 收益明细列表总条数
      totalNum: 0,

      // 时间区域 起始
      payStartTime: '',
      // 时间区域 完结
      payEndTime: '',
      // 收益明细对象
      earningObj: {},
      // 用户id
      userId: '',
      // 手机号
      userPhone: '',
      // 用户订单号
      userOrder: '',
      // 用户搜索弹出框文案
      dialodTitle: '',
      tableData: [],
      totalNum: 0,
      //------------------
      userIds: '',
    }
  },
  created() {
    this.userIds = this.$route.query.userId

    this.getBalanceClick()
  },
  updated() {
    if (this.$route.query.userId == undefined) {
      Bus.$emit('detele', 'partenrIncomeEarnings')
    }
  },
  methods: {
    getBalanceClick() {
      let params = {
        userId: this.userIds,
        userName: '',
        userPhone: '',
        status: '',
        createStartTime: '',
        createEndTime: '',
        type: 0,
        withdrawStatus: '',
        orderId: '',
        orderDetailId: '',
        //---------
        ordernumGood: this.userOrder,
        pay_userId: this.userId,
        payStartTime: this.payStartTime,
        payEndTime: this.payEndTime,
        pay_phone: this.userPhone,

        pageNo: this.page,
        pageSize: this.limit,
      }

      getBalance(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格数组
          this.tableData = res.resultData.balanceList
          // 获取总数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },
    // 用户点击查询搜索
    submitBtn() {
      // 输入框搜索值 请输入用户ID/手机号/订单号
      if (this.receiptValue != null) {
        this.payStartTime = this.receiptValue[0]
        this.payEndTime = this.receiptValue[1]
      } else {
        this.payStartTime = ''
        this.payEndTime = ''
      }

      this.getBalanceClick()
    },

    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      this.getBalanceClick()
    },
    //  查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      this.getBalanceClick()
    },
  },
}
</script>

<style lang="less" scoped>
.earnings {
  .earnings-headline {
    .headline-block {
      width: 100%;
      height: 142px;
      margin-top: 5px;
      background: #ffffff;
      display: flex;

      .headline-block-left {
        width: calc(100% * 0.9);
        height: 100%;
        display: flex;
        padding: 0 7px;
        box-sizing: border-box;

        border-radius: 5px;

        .headline-block-left-div {
          width: calc((100% / 2));
          height: 100%;
          align-items: center;
          display: flex;
          justify-content: center;

          .headline-block-left-div0 {
            padding: 10px 31px 0;
            box-sizing: border-box;
            height: 98px;
            width: 100%;

            .block-left-div0-top {
              height: 26px;
              display: flex;
              align-items: center;

              .block-left-div0-top-img {
                width: 26px;
                height: 26px;
              }

              .block-left-div0-top-title {
                margin-left: 14px;
                font-size: 14px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
              }
            }

            .block-left-div0-bottom {
              margin-top: 10px;

              .block-left-div0-bottom-price {
                font-size: 1.5rem;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: #29d647;
              }
            }
          }

          .headline-block-left-div1,
          .headline-block-left-div2 {
            height: 98px;
            background: #f7f7f7;
            border-radius: 4px;
            width: 100%;
            padding: 19px 21px 0;
            box-sizing: border-box;

            .block-left-div1-top {
              display: flex;
              height: 30px;
              align-items: center;

              .block-left-div1-top-text {
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #222222;
                line-height: 20px;
              }

              .block-left-div1-top-price {
                height: 30px;
                font-size: 26px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: #222222;
                line-height: 30px;
                margin-left: 7px;
              }

              .block-left-div1-top-rise {
                width: 18px;
                height: 19px;
                margin-left: 11px;
              }
            }

            .block-left-div1-bottom {
              display: flex;
              align-items: center;
              margin-top: 10px;
              justify-content: space-between;

              .block-left-div1-bottom-left {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #222222;
              }

              .block-left-div1-bottom-right {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #222222;
              }
            }
          }

          .headline-block-left-div2 {
            background: #fff;
          }
        }
      }

      .headline-block-right {
        margin-left: 10px;
        width: calc(100% * 0.4);
        height: 100%;
        background: linear-gradient(125deg, #084212 0%, #0e1924 100%);
        padding: 26px;
        box-sizing: border-box;
        display: flex;
        border-radius: 5px;
        justify-content: space-between;
        border: 1px solid;

        .headline-block-right-queer {
          .block-right-queer-title {
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
          }

          .block-right-queer-price {
            margin-top: 21px;
            font-size: 26px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #ffffff;
          }
        }

        .headline-block-right-dextro {
          position: relative;

          .block-right-dextro-withdraw {
            width: 71px;
            height: 30px;
            background: rgba(41, 214, 71, 0.21);
            border-radius: 4px;
            border: 1px solid rgba(41, 214, 71, 0.27);
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            position: absolute;
            right: 0;
            cursor: pointer;
          }

          .block-right-dextro-div {
            display: flex;
            margin-top: 54px;

            .dextro-div-usable,
            .dextro-div-lock {
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #d9d9d9;
            }

            .dextro-div-lock {
              margin-left: 21px;
            }
          }
        }
      }
    }

    .headline-third {
      width: 100%;
      background: #fff;
      margin-top: 10px;
      padding: 24px;
      box-sizing: border-box;

      .headline-third-top {
        height: 40px;
        display: flex;
        align-items: center;
        width: 100%;

        .headline-third0 {
          margin-right: 30px;
          cursor: pointer;
          display: flex;
          height: 40px;
          align-items: center;

          .headline-third0-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            margin-right: 10px;
          }

          /deep/ .el-input--suffix .el-input__inner {
            padding-right: 15px;
          }

          /deep/ .el-input {
            width: 170px;
          }

          /deep/ .el-input__inner {
            height: 32px;
            line-height: 32px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          /deep/ .el-input__icon {
            line-height: 32px;
          }
        }

        .headline-third1 {
          display: flex;
          height: 40px;
          align-items: center;

          .headline-third1-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            margin-right: 10px;

            .prefix-icon-class {
              display: none;
            }
          }

          /deep/ .el-date-editor .el-range-separator {
            width: 40px;
            line-height: 27px;
            font-size: 14px;
            display: flex;
            align-items: center;
          }

          /deep/ .el-input__inner {
            height: 32px;
          }

          /deep/ .el-input__icon {
            line-height: 25px;
          }

          /deep/ .el-input__inner {
            width: 280px;
          }
        }
      }

      .headline-third-bottom {
        display: flex;
        height: 40px;
        align-items: center;
        margin-top: 10px;
        justify-content: flex-start;

        .headline-third1-bottom {
          cursor: pointer;
          width: 60px;
          height: 32px;
          background: #29d647;
          border-radius: 5px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
          text-align: center;
        }
      }
    }

    .headline-table {
      cursor: pointer;

      /deep/ .el-table th.el-table__cell > .cell {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #565656;
      }

      /deep/ .el-table {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #717171;
      }

      padding: 0 24px;
      box-sizing: border-box;
      background: #fff;

      .earningStatusColor {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }

    .headline-paging {
      height: 102px;
      width: 100%;
      background: #ffffff;
      padding-right: 30px;

      /deep/ .el-pagination {
        display: flex;
        justify-content: flex-end;
        padding-top: 20px;
      }

      /deep/ .el-pager li {
        width: 32px;
        height: 32px;
        padding: 0;
        line-height: 32px;
        margin-right: 8px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li.active {
        background: #eafbed;
        border-radius: 4px;
        color: #29d647;
      }

      /deep/ .el-pager li:hover {
        color: #29d647;
      }

      /deep/ .el-pagination .btn-prev {
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/.el-pagination .btn-next {
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination button:hover {
        color: #29d647;
      }
    }
  }
}
</style>
